'use strict';

var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/demand-posting-chart-tooltip.html'));
var BreakdownChartController = function BreakdownChartController($scope, $filter, chartFormatter) {
  var DEFAULT_SELECTION = 60;
  var COLOR_MAP = {
    source: {
      model: '#355f94',
      effective: '#6da7de'
    },
    target: {
      model: '#f5a62f',
      effective: '#fcd38d'
    }
  };
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  function getLegend(mode) {
    return [{
      label: 'Model',
      fill: COLOR_MAP[mode].model
    }, {
      label: 'Effective',
      fill: COLOR_MAP[mode].effective
    }];
  }
  $scope.initChart = function () {
    $scope.legend = getLegend($scope.mode);
    $scope.renderChart($scope.chartData, DEFAULT_SELECTION);
  };
  $scope.viewportReset = function () {
    $scope.setViewportSelection(DEFAULT_SELECTION);
  };
  $scope.$watch('chartData', function (newVal) {
    if (newVal) {
      $scope.initChart();
    }
  });
  function dataFunction() {
    return $scope.chartData;
  }
  $scope.chartFormatters = {
    yAxisTickFormatter: chartFormatter.humanReadable,
    xAxisTickFormatter: chartFormatter.momentTick('DAY_MONTH_SHORT_NAME', 'DAY_OF_MONTH', 'date', dataFunction),
    tooltipFormatter: function tooltipFormatter(data) {
      return tooltipTemplate({
        mode: $scope.mode,
        model: rmNumberFormat(data.model, 'NUMBER'),
        effective: rmNumberFormat(data.effective, 'NUMBER'),
        change: data.change !== 0 ? rmNumberFormat(Math.abs(data.change), 'PERCENTAGE') : 'N/A',
        changeCss: data.change !== 0 && !_.isNaN(data.change) ? data.change : '',
        classGroup: data.classGroup,
        date: rmMomentFormat(data.date, 'DATE_USER_SETTINGS')
      });
    }
  };
  $scope.viewportFormatters = {
    xAxisTickFormatter: chartFormatter.momentTick('MONTH', undefined, 'date', dataFunction)
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'demand-posting-chart-tooltip in-modal';
};
BreakdownChartController.$inject = ['$scope', '$filter', 'FormatterService'];
module.exports = BreakdownChartController;